import axiosInstance from "../lib/axios.instance";
import type { Document, ISaveDocumentContent } from "../types/document.types";

export interface ICreateDocumentRequest {
  editor_id: string;
  title: string;
  content: string;
  collaborators: string[];
  folderId?: string | null;
}

export interface ICreateDocumentResponse {
  document_id: string;
}

const BASE_URL = "/documents";

/**
 * Get a document by ID
 */
export const getDocument = async (docID: string) => {
  const response = await axiosInstance.get<Document>(`${BASE_URL}/${docID}`);
  return response.data;
};

/**
 * Create a new document
 */
export const createDocument = async (
  payload: ICreateDocumentRequest
): Promise<ICreateDocumentResponse> => {
  try {
    const response = await axiosInstance.post<ICreateDocumentResponse>(`${BASE_URL}/`, payload);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || error.message || "Failed to create document");
  }
};

/**
 * Save document content
 */
export const saveDocumentContent = async (data: ISaveDocumentContent): Promise<void> => {
  await axiosInstance.put(`${BASE_URL}/${data.id}`, {
    content: data.content,
  });
};

/**
 * Convert HTML to SFDT
 */
export const convertHtmlToSfdt = async (htmlContent: string): Promise<string> => {
  try {
    const response = await axiosInstance.post<any>(
      `${process.env.WORDPROCESSOR_API_URL}documenteditor/SystemClipboard`,
      {
        content: htmlContent,
        type: ".html",
      }
    );
    return JSON.stringify(response.data);
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || error.message || "Failed to convert HTML to SFDT"
    );
  }
};
